var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-code",class:{'btn-disabled':_vm.countDown>-1},attrs:{"disabled":_vm.countDown>-1},on:{"click":function($event){$event.preventDefault();return _vm.doSend.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.textContent))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7b2dba12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/vCode.vue
// module id = null
// module chunks = 